import { Component, EventEmitter, Output, Input } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspace } from 'ionicons/icons';
import { CommonModule } from '@angular/common';

// Register icons
addIcons({ backspace });

@Component({
  selector: 'crowdctrl-alphabetic-keyboard',
  standalone: true,
  imports: [CommonModule, IonButton, IonIcon],
  templateUrl: './alphabetic-keyboard.component.html',
  styleUrl: './alphabetic-keyboard.component.css',
})
export class AlphabeticKeyboardComponent {
  @Input() maxLength: number = 18;
  @Input() value: string = '';
  @Input() disabled: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  readonly letters = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M'],
  ];

  onLetterClick(letter: string): void {
    if (this.disabled) return;
    if (this.value.length < this.maxLength) {
      const newValue = this.value + letter;
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }

  onBackspaceClick(): void {
    if (this.disabled) return;
    if (this.value.length > 0) {
      const newValue = this.value.slice(0, -1);
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }

  get isSpaceDisabled(): boolean {
    // Disabled if:
    // 1. Name is empty
    // 2. Last character is already a space (prevents double spaces)
    // 3. There is 1 available character left (to prevent space at end of name)
    if (this.value.length === 0) {
      return true;
    }
    if (this.value[this.value.length - 1] === ' ') {
      return true;
    }
    if (this.value.length >= this.maxLength - 1) {
      return true;
    }
    return false;
  }

  onSpaceClick(): void {
    if (this.disabled) return;
    if (!this.isSpaceDisabled && this.value.length < this.maxLength) {
      const newValue = this.value + ' ';
      this.value = newValue;
      this.valueChange.emit(newValue);
    }
  }
}
